import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { PageCounterContainer as i, BackgroundLine as c, PagesContainer as m, PageLabelContainer as s, PageNumber as b, PageLabel as p } from "./styles.js";
const C = ({ currentPageIndex: r, onNavigateToPage: t, pages: o }) => /* @__PURE__ */ n(i, { children: [
  /* @__PURE__ */ e(c, {}),
  /* @__PURE__ */ e(m, { children: o.map((l, a) => /* @__PURE__ */ n(s, { children: [
    /* @__PURE__ */ e(
      b,
      {
        type: "button",
        appearance: "accent",
        variant: r === a ? "primary" : "secondary",
        selected: r === a,
        disabled: a >= 1 && !o[a - 1].valid,
        onClick: () => t(a),
        children: a + 1
      }
    ),
    /* @__PURE__ */ e(p, { children: l.label })
  ] }, l.label)) })
] });
C.displayName = "HorizontalPageCounter";
export {
  C as HorizontalPageCounter
};
//# sourceMappingURL=HorizontalPageCounter.js.map
